const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

function toDateIfValidIsoDate(dateAsString) {
    if (!ISO_DATE_RE.test(dateAsString)) {
        throw new Error(`Invalid ISO date: ${dateAsString}`);
    }

    return new Date(dateAsString);
}

export function isFirstIsoTextDateBeforeSecondIsoTextDate(dateAsStringCheckedForBeingBefore, referenceDateAsString) {
    const dateCheckedForBeingBefore = toDateIfValidIsoDate(dateAsStringCheckedForBeingBefore);
    const referenceDate = toDateIfValidIsoDate(referenceDateAsString);
    return dateCheckedForBeingBefore < referenceDate;
}

Hop.defineModule('gdpr-update-acceptance', (root, params) => {
    const currentHostLocale = params.currentHostLocale;
    const GDPR_UPDATE_ACKNOWLEDGEMENT_API = '/api/webpref/gdpr-version-acceptance-acknowledgement';
    const LAST_GDPR_VERSION_API = `/api/seo/content/versions/last?humanId=policy&locale=${currentHostLocale}&type=privacy`;
    let latestVersion;

    const domAcceptCta = root.querySelector('#policyAcceptCta');

    async function shouldAskForAcceptanceOfLatestGdprPolicy() {
        const [versionSigned, lastVersion] = await Promise.all([
            Hop.get(GDPR_UPDATE_ACKNOWLEDGEMENT_API).then((data) => data.text()),
            Hop.get(LAST_GDPR_VERSION_API)
                .then((data) => data.text())
                .then((value) => (latestVersion = value)),
        ]);

        if (typeof lastVersion !== 'string') {
            throw new Error(`Invalid date received fot latest GDPR policy: ${lastVersion}`);
        }

        if (typeof versionSigned !== 'string' || versionSigned === '') {
            return true;
        }

        return isFirstIsoTextDateBeforeSecondIsoTextDate(versionSigned, lastVersion);
    }

    function shouldModalBeDisplayed() {
        const isPageLegal = document.querySelector('#privacy-policy-page');
        if (params.showFreelancerGdprModalOnUpdate && !isPageLegal) {
            return shouldAskForAcceptanceOfLatestGdprPolicy();
        }

        return Promise.resolve(false);
    }

    function displayModalIfNeeded(hasToBeDisplayed) {
        if (!hasToBeDisplayed) {
            return;
        }

        $(root).modal('show');
    }

    function acceptUpdate() {
        $.post(GDPR_UPDATE_ACKNOWLEDGEMENT_API, {
            value: latestVersion,
        });
    }

    function setupListeners() {
        domAcceptCta.addEventListener('click', acceptUpdate);
    }

    setupListeners();
    shouldModalBeDisplayed().then(displayModalIfNeeded);

    return function destroy() {
        domAcceptCta.removeEventListener('click', acceptUpdate);
    };
});
